import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import { router } from '@vue-storefront/core/app'
import { Logger } from '@vue-storefront/core/lib/logger'

export function afterRegistration({ Vue, store, isServer, config }): any {
  if (config.facebookPixel.id && !isServer) {
    window.facebookPixelSnippet(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
      () => {
        Vue.use(VueFacebookPixel, {
          router
        })
        /**
         * Init facebook tracking pixel
         * @param  {String} appId
         * @param  {object} [data={}]
         */
        Vue.analytics.fbq.init(config.facebookPixel.id, {
          em: config.facebookPixel.email
        })

        store.subscribe(({ type, payload }) => {
          if (type === 'product/product/SET_PRODUCT_CURRENT') {
            if (typeof Vue.analytics !== 'undefined') {
              /**
               * Event tracking
               * @param  {String} name
               * @param  {object} [data={}]
               */
              Vue.analytics.fbq.event('ViewContent', {
                content_name: payload.name,
                content_category: payload.category.slice(-1)[0].name,
                content_ids: [payload.sku],
                value: payload.price,
                currency: 'UAH',
                content_type: 'product'
              })
            }
          }
          if (type === 'cart/cart/ADD') {
            if (typeof Vue.analytics !== 'undefined') {
              /**
               * Event tracking
               * @param  {String} name
               * @param  {object} [data={}]
               */
              Vue.analytics.fbq.event('AddToCart', {
                content_name: payload.product.name,
                content_category: payload.product.category.slice(-1)[0].name,
                content_ids: [payload.product.sku],
                value: payload.product.price,
                currency: 'UAH',
                content_type: 'product'
              })
            }
          }
          if (type === 'order/order/LAST_ORDER_CONFIRMATION') {
            // Anywhere ("call a courier") and Insurance checkout never touch the shop cart, so
            // getGroupedByPartnerProducts has no matching group and this event would otherwise
            // never fire for these orders (K2-2595). Build it from the order response instead.
            if (['anywhere', 'insurance'].includes(payload.order.partner_code)) {
              const orders = payload.confirmation.orders || []
              const order = orders.find(o => o.partner_code === payload.order.partner_code) || orders[0]
              if (order && typeof Vue.analytics !== 'undefined') {
                Vue.analytics.fbq.event('Purchase', {
                  value: parseFloat(order.grand_total) || 0,
                  currency: 'UAH',
                  contents: [{
                    id: payload.order.partner_code === 'anywhere' ? 'ANY' : payload.order.partner_code.toUpperCase(),
                    quantity: 1
                  }],
                  content_type: 'product'
                })
              }
              return
            }

            store.getters['partners/getGroupedByPartnerProducts'].forEach(group => {
              let shippingAmount = 0
              let paidMethod = group.partner.shipping.methods.find(m => m.amount)
              if (paidMethod && (
                !group.partner.shipping.free
                || group.subtotal < group.partner.shipping.min_free_delivery_price
              )) {
                shippingAmount = paidMethod.amount
              }
              let products = group.items.map(product => {
                return {
                  id: product.sku,
                  quantity: product.qty ? product.qty : 1
                }
              });

              if (typeof Vue.analytics !== 'undefined') {
                /**
                 * Event tracking
                 * @param  {String} name
                 * @param  {object} [data={}]
                 */
                Vue.analytics.fbq.event('Purchase', {
                  value: group.subtotal + shippingAmount,
                  currency: 'UAH',
                  contents: products,
                  content_type: 'product'
                })
              }
            })
          }
        })
      })
  } else {
    Logger.warn('Facebook Pixel extension is not working. Ensure Facebook Pixel app ID is defined in config', '[Facebook Pixel]')()
  }
}

